import { call, put } from "redux-saga/effects";
import { userApi } from "@services/api";
import { getPopularInstructorActions } from "../slices";

function* getPopularInstructorWorker({ payload }) {
  try {
    yield put(getPopularInstructorActions.pending());
    const response = yield call(userApi.getPopularInstructor, payload);
    yield put(getPopularInstructorActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getPopularInstructorActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getPopularInstructorWorker };
